module.exports = __webpack_public_path__ + "img/homeDepot.36223e55.png";